/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: dpdRoEHB1RdkpQGeaRP58K
// Component: odaypzOMQtOx

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: dpdRoEHB1RdkpQGeaRP58K/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSliderBtn.module.css"; // plasmic-import: odaypzOMQtOx/css

createPlasmicElementProxy;

export type PlasmicSliderBtn__VariantMembers = {
  inactive: "inactive";
};
export type PlasmicSliderBtn__VariantsArgs = {
  inactive?: SingleBooleanChoiceArg<"inactive">;
};
type VariantPropType = keyof PlasmicSliderBtn__VariantsArgs;
export const PlasmicSliderBtn__VariantProps = new Array<VariantPropType>(
  "inactive"
);

export type PlasmicSliderBtn__ArgsType = { onClick?: () => void };
type ArgPropType = keyof PlasmicSliderBtn__ArgsType;
export const PlasmicSliderBtn__ArgProps = new Array<ArgPropType>("onClick");

export type PlasmicSliderBtn__OverridesType = {
  sliderBtn?: Flex__<"button">;
};

export interface DefaultSliderBtnProps {
  onClick?: () => void;
  inactive?: SingleBooleanChoiceArg<"inactive">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSliderBtn__RenderFunc(props: {
  variants: PlasmicSliderBtn__VariantsArgs;
  args: PlasmicSliderBtn__ArgsType;
  overrides: PlasmicSliderBtn__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "inactive",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.inactive
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <button
      data-plasmic-name={"sliderBtn"}
      data-plasmic-override={overrides.sliderBtn}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "button",
        "button__dpdRo",
        "root_reset_dpdRoEHB1RdkpQGeaRP58K",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.sliderBtn,
        { [sty.sliderBtninactive]: hasVariant($state, "inactive", "inactive") }
      )}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      ref={ref => {
        $refs["sliderBtn"] = ref;
      }}
      type={"button"}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  sliderBtn: ["sliderBtn"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  sliderBtn: "button";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSliderBtn__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSliderBtn__VariantsArgs;
    args?: PlasmicSliderBtn__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSliderBtn__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSliderBtn__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSliderBtn__ArgProps,
          internalVariantPropNames: PlasmicSliderBtn__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSliderBtn__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "sliderBtn") {
    func.displayName = "PlasmicSliderBtn";
  } else {
    func.displayName = `PlasmicSliderBtn.${nodeName}`;
  }
  return func;
}

export const PlasmicSliderBtn = Object.assign(
  // Top-level PlasmicSliderBtn renders the root element
  makeNodeComponent("sliderBtn"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicSliderBtn
    internalVariantProps: PlasmicSliderBtn__VariantProps,
    internalArgProps: PlasmicSliderBtn__ArgProps
  }
);

export default PlasmicSliderBtn;
/* prettier-ignore-end */
